import { render, staticRenderFns } from "./follaje.vue?vue&type=template&id=b05d0024&"
import script from "./follaje.vue?vue&type=script&lang=js&"
export * from "./follaje.vue?vue&type=script&lang=js&"
import style0 from "./follaje.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports